<script>
	import Tracker from '../components/Tracker.svelte';
	import { language, meditations } from '../stores/settings';

	import { getPrayerFactory, getMeditationFactory, rosaryLength } from './rosary';

	const getPrayer = getPrayerFactory($language);
	const getMeditation = getMeditationFactory($meditations);

	let index = 0;

	$: currentPrayer = getPrayer(index);
	$: currentMeditation = getMeditation(index);
	$: nextPrayer = getPrayer(index + 1);


	const up = () => index === 0 ? index = 0 : index--;
	const down = () => index === (rosaryLength - 1) ? index = rosaryLength - 1 : index++;

	const scrollHandler = ({ deltaY }) => deltaY < 0 ? up() : down();
	const keypressHandler = ({ key }) => {
		if (['ArrowLeft', 'ArrowUp', 'Backspace'].includes(key)) up();
		else if(['ArrowRight', 'ArrowDown', ' ', 'Enter'].includes(key)) down();
	}
</script>

<svelte:window on:keydown={keypressHandler} on:wheel={scrollHandler} />

<template>
	<div class="wrapper">
		<div class="container">
			<div class="prayer current">
				{currentPrayer}

				{#if currentMeditation}
					<div class="meditation">"{currentMeditation}"</div>
				{/if}
			</div>
			<div class="prayer next">{nextPrayer}</div>

			<div class="button-container">
				<button on:click={up}>Prev</button>
				<span>{index+1} / {rosaryLength}</span>
				<button on:click={down}>Next</button>
			</div>
		</div>

		<Tracker runningIndex={index} />
	</div>
</template>

<style lang="stylus">
	.wrapper
		height 100%
		display flex

	.container
		display flex
		height 100%
		flex-direction column
		align-items center
		justify-content space-between

	.prayer
		font-size 1.2rem
		max-width 60ch
		text-align center
		flex 1
		display flex
		flex-direction column
		align-items center
		justify-content center
		position relative

		&.current
			flex 5

		&.next
			overflow hidden
			user-select none
			justify-content flex-start
			opacity .5

		&.next:after
			content ''
			display block
			position absolute
			width 100%
			height 100%
			top 0

		&.next:after
			background linear-gradient(to bottom, transparent, black, black)

	.meditation
		padding 1rem
		font-size 1rem
		color #aaa
		font-style italic

	.button-container
		display flex
		align-items center
		margin 2rem

		button
			margin 1rem
			padding 0.75rem 3rem
			text-transform uppercase
			letter-spacing 0.05rem
			color white
			background transparent
			appearance none
			outline none
			border 1px solid rgba(white, 0.5)
			cursor pointer

			&:hover
				background rgba(white, 0.5)
	
</style>

